import React from 'react';
import PropTypes from 'prop-types';
import { useWhitelabelFeatures } from 'hooks/whitelabel/useWhitelabelFeatures';
import useWhitelabelEnvs from 'hooks/whitelabel/useWhitelabelEnvs';
import BusTrackerBanner from './BusTrackerBanner';
import AccommodationPromoBanner from './AccommodationPromoBanner';
import getPurchaseCompleteBannersVisibility from './purchaseCompleteBannersVisibility';

/**
 * PurchaseCompleteBanners component.
 * Render purchase complete promo banners; stacked on mobile, side by side from md breakpoint up.
 * @param {object} props - purchaseType, isOpenTicket.
 * @param {string} props.purchaseType - Purchase type (one_way/round_trip).
 * @param {boolean} props.isOpenTicket - Whether the purchase has open tickets.
 * @returns {JSX.Element|null} The rendered banners row or null.
 */
function PurchaseCompleteBanners({ purchaseType, isOpenTicket }) {
  const features = useWhitelabelFeatures();
  const env = useWhitelabelEnvs();
  const { busTracker, accommodation } = getPurchaseCompleteBannersVisibility(features, env);

  if (!busTracker && !accommodation) return null;

  const bothVisible = busTracker && accommodation;
  const imageColumnSize = bothVisible ? 'compact' : 'expanded';
  const bannerClassName = bothVisible ? 'w-full md:flex-1 md:min-w-0' : 'w-full';

  return (
    <div className="flex w-full flex-col gap-4 md:flex-row md:items-stretch">
      {accommodation && (
        <AccommodationPromoBanner
          purchaseType={purchaseType}
          isOpenTicket={isOpenTicket}
          className={bannerClassName}
          imageColumnSize={imageColumnSize}
        />
      )}
      {busTracker && (
        <BusTrackerBanner
          purchaseType={purchaseType}
          isOpenTicket={isOpenTicket}
          className={bannerClassName}
          imageColumnSize={imageColumnSize}
        />
      )}
    </div>
  );
}

PurchaseCompleteBanners.propTypes = {
  purchaseType: PropTypes.oneOf(['one_way', 'round_trip']),
  isOpenTicket: PropTypes.bool,
};

PurchaseCompleteBanners.defaultProps = {
  purchaseType: 'one_way',
  isOpenTicket: false,
};

export default PurchaseCompleteBanners;
